import Large from './Large';

export default Large;
